import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import StyleButtonBase from '../StyleButtonBase';

const StyledButtonLink = styled(Link)`
  ${StyleButtonBase}
`;

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
const defaultProps = {
  children: null,
  className: '',
};

function ButtonLink(props) {
  const { children, className } = props;

  const updatedClassName = `${className} button`;

  return (
    <StyledButtonLink {...props} className={updatedClassName}>
      {children}
    </StyledButtonLink>
  );
}

ButtonLink.propTypes = propTypes;
ButtonLink.defaultProps = defaultProps;

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/Components/Button/ButtonLink/index.jsx